import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppNav from "./AppNav";
import "./UploadCard.css";
import "./BookListPages.css";
import {
  cacheBookList,
  flushPendingBookListUpdates,
  getCachedBookList
} from "../utils/bookListCache";

function TBRPage() {
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBooks = useCallback(async () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const userId = JSON.parse(localStorage.getItem("user") || "{}").id || 0;

    if (!apiUrl || !userId) {
      setBooks([]);
      setLoading(false);
      return;
    }

    const cachedBooks = getCachedBookList(userId, "tbr");
    if (cachedBooks.length) {
      setBooks(cachedBooks);
      setLoading(false);
    }

    if (!navigator.onLine) return;

    try {
      await flushPendingBookListUpdates(apiUrl);
      const response = await fetch(`${apiUrl}/get-book-list.php?uid=${userId}&list=tbr`, {
        credentials: "include",
        cache: "no-store"
      });
      const data = await response.json();
      if (data?.success) {
        setBooks(data.items || []);
        cacheBookList(userId, "tbr", data.items || []);
      }
    } catch (error) {
      console.error("Failed to load TBR list:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBooks();
    document.body.style.backgroundColor = "#ffffff";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, [fetchBooks]);

  useEffect(() => {
    window.addEventListener("book-lists-updated", fetchBooks);
    return () => window.removeEventListener("book-lists-updated", fetchBooks);
  }, [fetchBooks]);

  return (
    <div className="book-list-page app-shell-page">
      <div className="container-fluid px-3 px-md-4 pt-4 pb-5">
        <div className="book-list-page__titlebar">
          <button type="button" className="book-list-page__back" onClick={() => navigate("/profile")}>
            <span className="material-symbols-rounded">arrow_back</span>
          </button>
          <div className="book-list-page__header">
            <h3 className="mb-0">
              To Be Read <span className="book-list-page__count-accent fw-normal">{`\u2022 ${books.length} books`}</span>
            </h3>
          </div>
        </div>

        {loading ? (
          <p className="book-list-page__empty mt-4">Loading your TBR...</p>
        ) : books.length === 0 ? (
          <p className="book-list-page__empty mt-4">Books you save for later will show up here.</p>
        ) : (
          <div className="book-list-stack mt-4">
            {books.map((book) => (
              <div
                key={book.id}
                className="upload-card-wrapper book-list-upload-card p-3 d-flex align-items-center gap-4 rounded-2"
                onClick={() => navigate(`/epub/${book.id}`)}
              >
                <div className="uploads-left d-flex align-items-center justify-content-center">
                  <span className="uploads-left-letter">{book.title?.charAt(0).toUpperCase()}</span>
                </div>

                <div className="uploads-middle d-flex flex-column gap-1 flex-grow-1">
                  <h5 className="mb-0">{book.title}</h5>
                  <p className="uploads-author mb-1">{book.author}</p>
                  <p className="book-list-upload-card__summary mb-0">
                    {book.summary || "No summary yet."}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <AppNav />
    </div>
  );
}

export default TBRPage;
